module.exports = __webpack_public_path__ + "static/media/forkify.ef4bc22c.png";